import ModalHeader from '@/components/modal/ModalHeader.tsx';
import ModalFooter from '@/components/modal/ModalFooter.tsx';
import Modal from '@/components/modal/Modal.tsx';
import React from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { debugZodResolver } from '@/lib/debugZodResolver';
import {
  TourOptionFormData,
  TourOptionInputForm,
  tourOptionSchema,
} from '@/features/dashboard/tourOptions/schemas/tourOptionSchema.ts';
import ActionButton from '@/components/buttons/ActionButton.tsx';
import { TourOptionDto } from '@/features/dashboard/tourOptions/types/TourOptionDto.ts';
import useUpdateTourOption from '@/features/dashboard/tourOptions/hooks/useUpdateTourOption.ts';
import {
  convertDtoToOptionForm,
  convertOptionFormToDto,
} from '@/features/dashboard/tourOptions/hooks/tourOptionConverter.ts';
import { tourOptionsConfigRoute } from '@/features/dashboard/tourOptions/routes/tourOptionsConfigRoute.ts';
import TourOptionsForm from '@/features/dashboard/tourOptions/components/TourOptionsForm.tsx';
import useGetTourOptionUsage from '@/features/dashboard/tourOptions/hooks/useGetTourOptionUsage.ts';

const TourOptionEditModal = ({
  onClose,
  tourOptionDto,
}: {
  onClose: () => void;
  tourOptionDto: TourOptionDto;
}) => {
  const { tourId } = tourOptionsConfigRoute.useParams();

  const { mutate: updateTourOption, isPending: isUpdating } =
    useUpdateTourOption(tourId);
  const { data: usage } = useGetTourOptionUsage(tourOptionDto.id);

  const tourOptionsForm = useForm<
    TourOptionInputForm,
    unknown,
    TourOptionFormData
  >({
    resolver: debugZodResolver(tourOptionSchema),
    defaultValues: convertDtoToOptionForm(tourOptionDto),
  });

  const onSubmit = (data: TourOptionFormData) => {
    const optionId: string = tourOptionDto.id;
    const dto = convertOptionFormToDto(tourId, data);
    updateTourOption(
      { optionId, dto },
      {
        onSuccess: () => {
          onClose();
        },
      },
    );
  };

  return (
    <Modal onClose={onClose} isDirty={tourOptionsForm.formState.isDirty}>
      <ModalHeader title={'Edytuj opcję dodatkową'} onClose={onClose} />
      <FormProvider {...tourOptionsForm}>
        <form onSubmit={tourOptionsForm.handleSubmit((d) => onSubmit(d))}>
          <TourOptionsForm isEdit usage={usage} />

          <ModalFooter>
            <ActionButton tone="outline" size="sm" onClick={onClose}>
              Anuluj
            </ActionButton>
            <ActionButton
              tone="accent"
              size="sm"
              type="submit"
              isLoading={isUpdating}
            >
              Zapisz zmiany
            </ActionButton>
          </ModalFooter>
        </form>
      </FormProvider>
    </Modal>
  );
};

export default TourOptionEditModal;
